import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { SettingsProvider } from './../../providers/settings/settings';

import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Device } from '@ionic-native/device';

declare var window: any;

@Injectable()
export class OnboardingProvider {
  sql_db = null;
  loginprocess: any;
  termsandconditions: any;

  constructor(
    public gateway: GatewayClientProvider,
    public settingsProvider: SettingsProvider,
    public device: Device,
    public http: Http) {

  }

  checkMobileNo(validMobileData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.checkMobileNo(validMobileData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * Check existing mobile no
   */
  checkExistingMobileNo(validMobileData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.checkExistingMobileNo(validMobileData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * Check existing email
   * @param validMobileData 
   */
  checkExistingEmail(validMobileData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.checkExistingEmail(validMobileData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  verifyOtp(otpData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.verifyOtp(otpData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })

    })
  }

  /**
   * Send otp to mmobile number
   * @param otpData 
   */
  sendOtp(otpData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.sendOtp(otpData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * Resend Otp
   * @param deviceData 
   */
  resendOtp(deviceData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.resendOtp(deviceData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * common function to change the status of the customer status
   * @param deviceData 
   */
  changeCustomerStatus(deviceData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.changeCustomerStatus(deviceData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  block_OTP(deviceData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.blockOTP(deviceData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  app_blocK(deviceData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.addStateStatusOfaccount(deviceData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  setPin(setPinData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.setPin(setPinData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  setPassword(setPasswordData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.setPassword(setPasswordData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  getAccountTypes() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getaccounttypes()
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
    * Get status of the register customer
    * @param statusData 
  */
  getStatus() {
    let self = this;
    return new Promise(function (resolve, reject) {
      if (self.device.platform.toLowerCase() == 'android' || self.device.platform.toLowerCase() === 'ios') {
        self.sql_db = window.sqlitePlugin.openDatabase({ name: 'consectus.db', location: 'default' });
        self.sql_db.transaction(function (transaction) {
          transaction.executeSql("SELECT uuid FROM tbl_new_accounts LIMIT 1", [], function (tx, result) {
            let statusData = {
              "uuid": result.rows.item(0).uuid ? result.rows.item(0).uuid : "",
              "devicetype": self.device.platform,
              "new_accounts_id": self.settingsProvider.settings.newAccountId
            }
            self.gateway.getStatusbyUUID(statusData)
              .then((data) => {
                resolve(data);
              }).catch((err) => {
                reject(err);
              })
          },
            function (tx, error) {

              reject(error);
            });
        })
      }
      else {

      }
    })
  }

  /**
    * Get status of the register customer
    * @param statusData 
  */
  getStatus_by_UUID(statusData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getStatusbyUUID(statusData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
    * Get status of the existing customer new product application
    * @param statusData 
  */
  get_ProductApplicationStatus(statusData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getProductApplicationStatus(statusData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * Get register filed data for hide/show
   */
  getRegistrationFields() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getRegistrationFields()
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * Get Onboarding Process for verify customer
   */
  getOnboardingProcess() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getOnboardingProcess()
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * Get Login touch id data
   */
  getloginprocess() {
    let isloginprocessexist = false;
    if (this.loginprocess != undefined) {
      isloginprocessexist = true
    }
    let self = this;
    return new Promise(function (resolve, reject) {
      if (isloginprocessexist) {
        resolve(self.loginprocess)
      }
      self.gateway.getloginprocess()
        .then((data) => {
          self.loginprocess = data;
          if (!isloginprocessexist) {
            resolve(self.loginprocess);
          }
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * New Registration on boarding register
   * @param registerData
   */

  newOnBoardingRegister(registerData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.newOnBoardingRegister(registerData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  verifyregisterformsopra(registerData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.verifyregisterformsopra(registerData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  getrulesenginebyaccounttypes(account_types_id) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getrulesenginebyaccounttypes(account_types_id)
        .then((data: any) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * VerifyMailer data using member id 
   * @param verifyMailerData 
   */
  verifyMailer(verifyMailerData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.verifyMailer(verifyMailerData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  /**
   * VerifyMailer data using member id 
   * @param verifyMailerData 
   */
  verifymailerforgotpin(verifyMailerData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.verifymailerforgotpin(verifyMailerData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * VerifyMailer data using member id 
   * @param blockSubject 
   */
  getContactSubjectBySubject(blockSubject) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getContactSubjectBySubject(blockSubject)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  getAccountBanksetting(devicetype) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getAccountBanksetting(devicetype)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  getRegisterationStatus() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getRegisterationStatus()
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  getBlockedCustomerStatus(registerCustomerStatus) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getBlockedCustomerStatus(registerCustomerStatus)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  sendTnCMail(sendMail) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.sendTnCMail(sendMail)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  get_addressLines(selectedId) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.get_addressLines(selectedId)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  getAddress(pCode) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.get_address(pCode)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  postalcode_api_fail() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.postalcodeapi_fail()
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * verify device pin after new Existing install on another phone
   */
  verifydevicepinfornewexisting(verifyPinData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.verifydevicepinfornewexisting(verifyPinData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * Login with pin
   * @param loginData 
   */
  loginWithPin(loginData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.loginwithpin(loginData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * Login with pin
   * @param loginData 
   */
  loginWithTouchId(loginData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.loginWithTouchId(loginData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * select product for new account
   * @param selectNewAccount 
   */

  // step one new account opening
  getaccounttypesandproducts() {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getaccounttypesandproducts()
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * verify email for Product form
   * @param getuniqueemail 
   */

  // step one new account opening
  getUniqueEmail(emailid) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getUniqueEmail(emailid)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * verify email for Product form
   * @param getuniqueemail 
   */

  // step one new account opening
  getUniqueMobile(Mod) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getUniqueMobile(Mod)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * verify email for Product form
   * @param getuniqueemail 
   */

  // step one new account opening
  updateProductApplicationStatus(status_state) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.updateProductApplicationStatus(status_state)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }


  /**
  * select proceed for new account apply
  * @param createNewAccount 
  */
  createNewAccount(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.createNewAccount(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * apply application form for selected product;
   * @param applicationForm 
   */
  newAccountRegister(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.newAccountRegister(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * apply application form for selected product;
   * @param applicationForm 
   */
  createAccountForExistingCustomer(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.createAccountForExistingCustomer(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  insertNewaccountwithoutcallcredit(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.insertnewaccountwithoutcallcredit(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  newcustomeraccountregisteraftersmartsearch(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.newcustomeraccountregisteraftersmartsearch(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  insertexistingaccontwithoutcallcredit(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.insertexistingaccontwithoutcallcredit(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * Verify unique code 
   * @param verifyCode 
   */
  verifySecurityCode(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.verifySecurityCode(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }


  /**
   * Validate reset pin
   * @param data 
   */
  validateresetpin(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.validateresetpin(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
   * reset pin
   * @param data 
   */
  resetpin(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.resetpin(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  getTermsConditions() {
    let istermsexist = false;
    if (this.termsandconditions != null) {
      istermsexist = true;
    }
    let self = this;
    return new Promise(function (resolve, reject) {
      if (istermsexist) {
        resolve(self.termsandconditions)
      }
      self.gateway.getTermsandCondition()
        .then((data) => {
          self.termsandconditions = data;
          if (!istermsexist) {
            resolve(data);
          }
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
  * addupdatepycassodocs
  * @param data 
  */
  addupdate_pycassodocs(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.addupdatepycassodocs(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  sendUserOtp(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.sendUserOtp(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  validateUserOtp(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.validateUserOtp(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  newcustomerResidency(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.newcustomerResidency(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  newcustomerTnc(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.newcustomerTnc(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  newcustomerSelectedProduct(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.newcustomerSelectedProduct(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  regularfrequency(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.regularfrequency(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  fundsOrigin(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.fundsOrigin(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  personalDetails(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.personalDetails(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  addressDetails(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.addressDetails(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  nbaDetails(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.nbaDetails(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  istaxresident(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.istaxresident(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  /**
 * UpdateNBA Details
 */
  update_nba_details(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.updatenbadetails(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  newccountregister(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.newccountregister(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  // api for online login
  web_login_api(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.webloginapi(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  ///api for user id verification
  web_user_verification(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.webuserverification(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  ///api for user mob verification
  web_user_mob_verification(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.webusermobverification(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  ///api for user mob otp verification
  web_user_mob_otp_verification(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.webusermobotpverification(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  ///api for send passcode through email
  email_passcode(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.emailpasscode(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  ///api for change emailid as user id 
  email_as_userid(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.emailasuserid(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  //////Online New Registrationon for passbookcustomer////

  passbookusercustomer(registerData) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.passbookusercustomeronline(registerData)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  ///api for ncao user id verification
  web_user_Register_new_online_device(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.WebuserRegisternewonlinedevice(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  ///api for ncao user id verification
  send_passcode_register_new_online_device(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.SendpasscodetoRegisternewonlinedevice(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  ///api for ncao user passcode verification
  verify_passcode_register_new_online_customer(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.Verifypasscodefornewregisteronlinedevice(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  /** Verify unique code for online **/
  verifyuniqueSecurityCode(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.verifyuniqueSecurityCode(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  smartSearch_CheckDoc(data: any) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.smartSearch_CheckDoc(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  get_smartSearchDocData(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.get_smartSearch_DocData(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
  juniorcreatenewsavingaccount(data) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.juniorcreatenewsavingaccount(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  updateNINumber(data: any) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.UpdateNINumber(data)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }

  getNbaDetailsByAccount(customer_id, accountno) {
    let self = this;
    return new Promise(function (resolve, reject) {
      self.gateway.getNbaDetailsByAccount(customer_id, accountno)
        .then((data) => {
          resolve(data);
        }).catch((err) => {
          reject(err);
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/providers/onboarding/onboarding.ts